import { useId, useState } from "react";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

/**
 * "AI filter": for now only the field (owner, 30.10.2026 - variant 23 as a
 * placeholder). When it is wired up, the phrase becomes ordinary chips shown
 * for a check before they apply; nothing applies on its own.
 */
export function AiFilterButton() {
  const id = useId();
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [asked, setAsked] = useState(false);

  return (
    <Popover
      open={open}
      onOpenChange={(o) => {
        setOpen(o);
        if (!o) setAsked(false);
      }}
    >
      <PopoverTrigger asChild>
        <button
          type="button"
          className="inline-flex cursor-pointer items-center gap-1 rounded-full border border-dashed border-border px-2.5 py-1 text-xs text-muted-foreground hover:bg-muted hover:text-foreground"
        >
          <Sparkles className="size-3" aria-hidden /> AI filter
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 space-y-2 p-3">
        <label htmlFor={id} className="block text-sm font-medium">
          Describe the filter
        </label>
        <textarea
          id={id}
          autoFocus
          rows={2}
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              if (text.trim()) setAsked(true);
            }
          }}
          placeholder="e.g. DE and PL without bots, SEO campaigns only"
          className="w-full resize-none rounded-md border border-border bg-transparent px-2 py-1.5 text-sm outline-none focus-visible:ring-1 focus-visible:ring-ring"
        />
        {asked ? (
          <p role="status" className="text-xs text-muted-foreground">
            AI filters are coming soon: the phrase will turn into regular chips you check before they apply. For now,
            use + Filter or the Filters list.
          </p>
        ) : (
          <p className="text-[11px] text-muted-foreground">Not connected yet.</p>
        )}
        <div className="flex justify-end">
          <Button size="sm" className="h-7" disabled={!text.trim()} onClick={() => setAsked(true)}>
            Apply
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
